import { api } from "../api";

export const mmbService = {
  retrieveBooking,
  confirmChanges,
  resetBooking,
  cancelFlight,
  cancelPassenger,
  checkCancelFlight,
  resendItinerary,
  updateContact,
  processDisruption,
  confirmSeat,
  addInfant,
  feedback,
};

function retrieveBooking(pnr, lastName) {
  const data = {
      pnr,
      lastName
    };

    return api.getFetch(`api/manage/retrieve`, data)
}

function confirmChanges() {
  return api.postFetch(`api/manage/confirm`)
}

function resetBooking() {
  return api.postFetch(`api/manage/resetbooking`)
}

// flights is an array of number containing the logical flight id of flights to cancel
function cancelFlight(flights) {
  return api.postFetch(`api/manage/cancelFlight`, {flights})
}

function cancelPassenger(flights) {
  return api.postFetch(`api/manage/cancelPassenger`, {flights})
}

function checkCancelFlight() {
  return api.getFetch(`api/manage/cancelFlight`)
}

function resendItinerary(email) {
  return api.postFetch(`api/manage/resendItinerary`, {email})
}

function updateContact(data) {
  return api.postFetch(`api/manage/contact`, data)
}

function processDisruption(action) {
  const data = {
    action
  };
  return api.postFetch(`api/manage/disruption`, data)
}

function confirmSeat() {
  return api.postFetch(`api/manage/confirmSeat`)
}

function addInfant(data) {
  return api.postFetch(`api/manage/addInfant`, data);
}

function feedback(data) {
  return api.postFetch(`api/manage/feedback`, data);
}
